<style lang='scss'>
@import './../assets/sass/colors';

.billboard {
  height: 100vh;
}

.billboard img {
  width: 100%;
  height: auto;
  position:absolute;
}

.billboard-parallax .billboard {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: -1;
  overflow: hidden;
}

.billboard-parallax .billboard + * {
  margin-top: 100vh;
  position: relative;
  z-index: 1;
  min-height: 100vh;
  background-color: $base-secondary-color;
}

.billboard.small {
  height: 50vh;
}

.billboard-parallax .billboard.small + * {
  min-height: 50vh;
  margin-top: 50vh;
}
</style>

<template lang='pug'>
  div
    app-header(ref='header' useAlternate='true')
    main
      transition(name='fade', mode='out-in')
        router-view
          template(slot='billboard' slot-scope='billboard')
            component.billboard(:is='billboard.content' v-bind='billboard.data')
          slot
    app-footer
    vue-modal(
      v-if='modalProperties.isShown',
      :options='modalProperties.style')
      component(:is='modalProperties.content', v-bind='modalProperties.params')
</template>
<script>
import AppHeader from './app-header.vue'
import AppFooter from './app-footer.vue'
import VueModal from 'vue-modal'
import ScrollMonitor from 'scrollmonitor'

export default {
  meta: {
    title: 'Spirits & Liquor Direct',
    titleTemplate: '%s - Inom PH'
  },
  data () {
    return {
      watcher: null
    }
  },
  mounted () {
    this.watcher = ScrollMonitor.create(192)
    this.watcher.stateChange(() => {
      if (this.watcher.isAboveViewport) {
        this.$refs.header.fix()
      } else {
        this.$refs.header.unfix()
      }
    })
  },
  destroyed () {
    this.watcher.destroy()
  },
  computed: {
    modalProperties () {
      return {
        isShown: this.$store.state.modal.isShown,
        content: this.$store.state.modal.content,
        params: this.$store.state.modal.bind,
        style: this.$store.state.modal.style
      }
    }
  },
  components: {
    AppHeader,
    AppFooter,
    VueModal
  }
}
</script>



// WEBPACK FOOTER //
// src/components/template-billboard.vue